type Listener<T> = (value: T) => void;

/**
 * Minimal typed event emitter, so the app does not need the Node `events`
 * polyfill (and therefore no npm dependencies at all).
 */
export class Emitter<T> {
  private listeners: Listener<T>[] = [];

  on(listener: Listener<T>) {
    this.listeners.push(listener);
  }

  protected emit(value: T) {
    for (const listener of this.listeners) {
      listener(value);
    }
  }
}

/** Anything that can report a speed in km/h. */
export interface SpeedSource extends Emitter<number> {
  start(): void;
  stop(): void;
}
